import React from 'react';
import './App.scss';
import styled from 'styled-components';
import 'antd/dist/antd.less';



import LoginOption from './LoginOption';
import { Button } from 'antd';

const options = [
  {
    title: "External Users",
    description: `
    If you do not have a custom MBS-ID and/or you are not an enrolled student at Mannheim Business School,
    please log in here.
    `,
    extra: [<Button type="primary" size="large" href={"https://mannheim.instructure.com/login/canvas"} style={{ width: "60%" }}>Canvas</Button>]
  },
  {
    title: "MBS ID",
    description: `
    Users with an MBS ID please log in here.
    `,
    extra: [
      <Button type="primary" size="large" href={"https://mannheim.instructure.com/login/saml"} style={{ marginBottom: "1rem", width: "60%" }}>Canvas</Button>,
      <Button type="primary" size="large" href={"https://portal.office.com"} style={{ width: "60%" }}>Office 365</Button>
    ]
  }
]


function App() {
  return (
    <div className="App">
      <Container>
        <Image>
          <img
            style={{ width: '100%' }}
            src="https://mbsxs3.s3.eu-central-1.amazonaws.com/Website/images/Logo+MBS+HQ%408x.png"
            alt="Mannheim Business School Logo"
          />
        </Image>
        <Content>
          {options.map((option, index) => (
            <Col>
              <LoginOption props={option} key={index} />
            </Col>
          ))}
        </Content>
      </Container>
    </div>
  );
}

export default App;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start; 
  min-height: 100vh;
  height: auto;
  overflow: visible;
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  background-image: linear-gradient(to right bottom, rgba(35, 46, 88, 0.98), rgba(172, 185, 203, 0.95)), url('https://d22k1eikrwb2dp.cloudfront.net/images/schloss-1600px.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
`

const Content = styled.div`
  margin: auto;
  margin-top: -2rem;
  display: flex;
  width: 90%;
  justify-content: space-around;
  @media (max-width: 800px) {
    flex-direction: column;
    margin: auto;
    margin-top: 3rem;
  }
`

const Image = styled.div`
  margin: auto;
  width: 35%;
  @media (max-width: 800px) {
    width: 60%;
    margin: auto;
    margin-top: 3rem;
  }
`

const Col = styled.div`
  flex: 1
`